import { render, staticRenderFns } from "./IntegrationsTable.vue?vue&type=template&id=0a1e73f8&lang=pug&"
import script from "./IntegrationsTable.vue?vue&type=script&lang=js&"
export * from "./IntegrationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports